/** Content type UIDs for "External Sources" (Webinars, Podcasts, etc.) - used by catalog and search */
export const EXTERNAL_SOURCE_CONTENT_TYPES = ['webinar', 'podcast', 'developer-spotlight', 'pulse', 'change_logs'];

/**
 * Map content type term name to search index tags.
 * Search index uses tags like "course", "courses", "content", "demo" - not taxonomy term UIDs.
 * Course/Courses both map to ["course", "courses"] so filter matches items with either tag.
 * External sources (Webinar, Podcast, etc.) use hyphenated slugs in the index.
 */
export function termNameToSearchTags(name: string): string[] {
  const n = (name || '').toLowerCase().trim();
  if (n === 'course' || n === 'courses') return ['course', 'courses'];
  if (n === 'explainer' || n === 'explainers') return ['explainer', 'explainers'];
  if (n === 'webinar' || n === 'webinars') return ['webinar'];
  if (n === 'podcast' || n === 'podcasts') return ['podcast'];
  if (n === 'developer spotlight' || n === 'developer-spotlight') return ['developer-spotlight'];
  if (n === 'pulse') return ['pulse'];
  if (n === 'change log' || n === 'change_log' || n === 'change_logs' || n === 'change logs') return ['change_logs'];
  if (n) return [n.replace(/\s+/g, '_'), n.replace(/\s+/g, '-')];
  return [];
}

/** Items per page: 6 for tab (2 cols × 3 rows), 9 for desktop (3 cols × 3 rows) */
export const PER_PAGE_TAB = 6;
export const PER_PAGE_DESKTOP = 9;

/** Catalog search: min/max length and debounce (used by search bar and catalog page) */
export const SEARCH_MIN_LENGTH = 3;
export const SEARCH_MAX_LENGTH = 120;
export const SEARCH_DEBOUNCE_MS = 400;
